import { FormEvent, useEffect, useState } from 'react';
import { useChangeStatusMutation, useTerminSyncMutation } from '../../api/AuftragAPI';
import DialogAuftragComponent from '../../component/DialogAuftragComponent/DialogAuftragComponent';
import DialogAuftragTerminAendernComponent from '../../component/DialogAuftragTerminAendernComponent/DialogAuftragTerminAendernComponent';
import { LoadingModal } from '../../component/LoadingModal/LoadingModal';
import { IAuftrag } from '../../types/Types';
import { formatToEuroDateTime } from '../../util/DateUtils';
import { useGetAuftragTableOrderServiceMutation, useSetAuftragTableOrderServiceMutation } from '../../api/ProfileAPI';

/**
 * @author noone
 */
export type ThisProps = {
  liste: IAuftrag[];
  statusChanged: () => void;
}
export default function AuftragAnzeigeTerminiert(props: ThisProps) {

  const [changeStatusAPI] = useChangeStatusMutation();
  const [terminSyncAPI] = useTerminSyncMutation();
  const [getProfileParameter] = useGetAuftragTableOrderServiceMutation();
  const [setProfileParameter] = useSetAuftragTableOrderServiceMutation();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [sortList, setSortList] = useState(new Map<number, number>());
  const [auftragsliste, setAuftragsliste] = useState<IAuftrag[]>([]);
  const [dialogTerminAendernVisible, setDialogTerminAendernVisible] = useState<boolean>(false);
  const [dialogAuftragVisible, setDialogAuftragVisible] = useState<boolean>(false);
  const [selectedAuftrag, setSelectedAuftrag] = useState<IAuftrag | null>(null);

  const statusChanged = () => {
    props.statusChanged();
  }

  const handleNextStatus = (uid: string, nextstatus: string) => {
    changeStatusAPI({ uid: uid, neuerStatus: nextstatus }).then(() => statusChanged());
  }

  const getIconBySort = (column: number) => {
    if (sortList.get(column) === -1) {
      return "bi bi-arrow-down";
    } else if (sortList.get(column) === 1) {
      return "bi bi-arrow-up";
    } else {
      return "bi bi-arrow-down-up";
    }
  }

  const sort = (number: number) => {
    sortList.forEach((value, key) => {
      if (key !== number) {
        sortList.set(key, 0);
      } else {
        if (value === 0) {
          sortList.set(key, 1);
        } else if (value === 1) {
          sortList.set(key, -1);
        } else {
          sortList.set(key, 0);
        }
      }
    });
    sortListeByColumn(number);
  }

  const sortListeByColumn = (column: number) => {
    auftragsliste.sort((a, b) => {
      if (column === 1) {
        if (sortList.get(column) === 1) {
          return a.art > b.art ? 1 : -1;
        } else if (sortList.get(column) === -1) {
          return a.art > b.art ? -1 : 1;
        } else return 0;
      } else if (column === 2) {
        if (sortList.get(column) === 1) {
          return a.name_endkunde > b.name_endkunde ? 1 : -1;
        } else if (sortList.get(column) === -1) {
          return a.name_endkunde > b.name_endkunde ? -1 : 1;
        } else return 0;
      } else if (column === 3) {
        if (sortList.get(column) === 1) {
          return a.strasse_lieferadresse > b.strasse_lieferadresse ? 1 : -1;
        } else if (sortList.get(column) === -1) {
          return a.strasse_lieferadresse > b.strasse_lieferadresse ? -1 : 1;
        } else return 0;
      } else if (column === 4) {
        if (sortList.get(column) === 1) {
          return a.stadt_lieferadresse > b.stadt_lieferadresse ? 1 : -1;
        } else if (sortList.get(column) === -1) {
          return a.stadt_lieferadresse > b.stadt_lieferadresse ? -1 : 1;
        } else return 0;
      } else if (column === 5) {
        const dateA = a.aktuellerTermin ? new Date(a.aktuellerTermin).getTime() : 0;
        const dateB = b.aktuellerTermin ? new Date(b.aktuellerTermin).getTime() : 0;
        if (sortList.get(column) === 1) {
          return dateA - dateB;
        } else if (sortList.get(column) === -1) {
          return dateB - dateA;
        } else return 0;
      } else return 0;
    });

    setAuftragsliste([...auftragsliste]);

    setProfileParameter({
      key: "auftrag_terminiert_ansicht", value: JSON.stringify({
        art: sortList.get(1) || 0,
        name: sortList.get(2) || 0,
        strasse: sortList.get(3) || 0,
        lieferort: sortList.get(4) || 0,
        termin: sortList.get(5) || 0
      })
    })
      .unwrap().catch((error) => console.log(error));
  }

  const terminSync = () => {
    setIsLoading(true);
    terminSyncAPI().unwrap()
      .catch((error) => console.log(error))
      .finally(() => setIsLoading(false))
      ;
  }

  useEffect(() => {
    sortList.forEach((value, key) => {
      if (value !== 0) {
        sortListeByColumn(key);
      }
    });
  }, [sortList]);

  useEffect(() => {
    setAuftragsliste([...props.liste]);

    getProfileParameter("auftrag_terminiert_ansicht").unwrap().then((dto) => {
      sortList.set(1, dto.art);
      sortList.set(2, dto.name);
      sortList.set(3, dto.strasse);
      sortList.set(4, dto.lieferort);
      sortList.set(5, dto.termin);
      setSortList(new Map(sortList));
    }).catch((error) => {
      console.log(error);
      setSortList(new Map([
        [1, 0], // Art
        [2, 0], // Name
        [3, 0], // Strasse
        [4, 0], // Lieferort
        [5, 0], // Termin
      ]));
    });

  }, [props]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (

    <div>

      <LoadingModal show={isLoading} />

      <DialogAuftragComponent uid_auftrag={selectedAuftrag?.uid} close={() => setDialogAuftragVisible(false)} dialogVisible={dialogAuftragVisible} />
      <DialogAuftragTerminAendernComponent uid_auftrag={selectedAuftrag?.uid} close={() => setDialogTerminAendernVisible(false)} dialogVisible={dialogTerminAendernVisible} refresh={() => props.statusChanged()} statusChanged={() => statusChanged()} />

      {auftragsliste?.length === 0 && <div>Keine Aufträge vorhanden</div>}

      <button className="btn btn-info" onClick={() => terminSync()}><i className="bi bi-arrow-repeat"></i> Sync</button>

      <table className="table" style={{ width: "100%", marginTop: "20px" }}>
        <thead>
          <tr>
            <th scope="col" onClick={() => { sort(1) }}>Art <i style={{ marginLeft: "10px" }} className={getIconBySort(1)} /></th>
            <th scope="col" onClick={() => { sort(2) }}>Name <i style={{ marginLeft: "10px" }} className={getIconBySort(2)} /></th>
            <th scope="col" onClick={() => { sort(3) }}>Strasse <i style={{ marginLeft: "10px" }} className={getIconBySort(3)} /></th>
            <th scope="col" onClick={() => { sort(4) }}>Ort <i style={{ marginLeft: "10px" }} className={getIconBySort(4)} /></th>
            <th>Ausführung von</th>
            <th>Auftragsnr. Kunde</th>
            <th scope="col" onClick={() => { sort(5) }}>Termin <i style={{ marginLeft: "10px" }} className={getIconBySort(5)} /></th>
            <th scope="col">Option</th>
          </tr>
        </thead>
        <tbody>

          {auftragsliste?.map((auftrag, index) => (
            <tr key={index}>
              <td>{auftrag.art}</td>
              <td>{auftrag.name_endkunde}</td>
              <td>{auftrag.strasse_lieferadresse} {auftrag.hausnummer_lieferadresse}</td>
              <td>{auftrag.stadt_lieferadresse}</td>
              <td>{auftrag.ausfuehrungvon?.name}</td>
              <td>{auftrag.auftragsnr_ag}</td>
              <td>{formatToEuroDateTime(auftrag.aktuellerTermin)}</td>
              <td>
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setSelectedAuftrag(auftrag);
                    setDialogAuftragVisible(true);
                  }} ><i className='bi bi-pencil-fill'></i></button>
                <button className='btn btn-secondary' onClick={() => {
                  setSelectedAuftrag(auftrag);
                  setDialogTerminAendernVisible(true);
                }} ><i className='bi bi-calendar'></i> Termin ändern</button>
                <button className='btn btn-primary' onClick={() => handleNextStatus(auftrag.uid, "FAKTURIERBAR")} >Freigeben zur Rechnungsstellung <i className='bi bi-arrow-right'></i> </button>

              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

}
